import { EyeIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react'
import { useLoaderData } from 'react-router-dom';
import { LoadingData } from '../../components/Loading';
import Pagination from '../../components/Pagination';

export default function Transactions() {
  const [data, setData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(1);
  const [selectTransaction, setSelectedTransaction] = useState({});
  const [loading, setLoading] = useState(false);

  const serverData = useLoaderData()

  useEffect(() => {
    setData(serverData)
    return () => { }
  }, [serverData])
  
  useEffect(() => {
    if (data && data.docs) {
      setTransactions(data?.docs);
    }
  }, [data])

  const openTransaction = (transaction) => {
    setSelectedTransaction(transaction);
  }

  return (
    <div className="w-full">
      <h4 className="text-xl font-fira font-semibold capitalize">Transactions</h4>
      <div className="mt-6 bg-white pt-3 rounded-lg">
        <div className="">
          <div className="px-4 mb-4 flex justify-between items-center">
            <h4 className="text-sm font-semibold font-fira text-gray-800">All transactions</h4>
            <h4 className="text-xs font-semibold text-gray-800">Current Page {page}</h4>
          </div>
          <div className="w-full overflow-x-scroll">
            <table className="min-w-max w-full table-auto">
              <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                <tr>
                  <th className="py-3 px-8 text-left">User</th>
                  <th className="py-3 px-8 text-left">Amount</th>
                  <th className="py-3 px-8 text-left">Reference Code</th>
                  <th className="py-3 px-8 text-left">Payment Type</th>
                  <th className="py-3 px-8 text-left"></th>
                </tr>
              </thead>
              <tbody>
                {Array.from(transactions).map((tx) => (
                  <tr key={tx._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <div className="flex gap-2 items-center justify-center">
                        <img src={tx.user.avatar} alt="avatar" className="w-8 h-8 rounded-full border-2 border-gray-200" />
                        <div>
                          <h4 className="text-xs font-semibold">{tx.user.name}</h4>
                          <a className="text-xs text-blue-900" href={`mailto:${tx.user.email}`}>{tx.user.email}</a>
                        </div>
                      </div>
                    </td>
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span>{tx.amount} {tx.currency}</span>
                    </td>
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span>{tx.ref}</span>
                    </td>
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span className="capitalize">{tx.paymentType}</span>
                    </td>

                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <button onClick={() => {
                        openTransaction(tx);
                      }} className='flex gap-1 items-center'>
                        <span>
                          <EyeIcon className="h-4 w-4" />
                        </span>
                        <span className='whitespace-nowrap'>View Transaction</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
          {(transactions.length < 1 && !loading) && <div className="no-case flex py-8 px-6 flex-col justify-center gap-6">
            <div className="text-center">
              <h4 className="font-semibold font-fira text-lg">No Transaction Record</h4>
            </div>
          </div>}

          {loading && <div className="mt-10">
            <LoadingData message="Loading Transactions..." />
          </div>}
        </div>
      </div>
      {<Pagination currentData={data} setData={setData} setLoading={setLoading} />}
    </div>
  )
}
